import {
  FilterMode,
  NotificationFormProps,
  NotificationFormValues,
} from "./types";
import { isEmptyStr } from "../../util/StringUtil";
import DateUtil from "../../util/DateUtil";

export const mapNotificationPropsToValues = ({
  notification,
}: NotificationFormProps): NotificationFormValues => {
  // Calculate stopSending values from notification when present
  let stopSendingTimeValue = 5;
  let stopSendingTimeUnit: "minutes" | "hours" | "custom" = "minutes";
  let stopSendingCustomUnit: "minutes" | "hours" = "minutes";
  let stopSendingCustomValue = 15;

  if (
    notification?.LocalScheduleSendDateTime &&
    notification?.MaximumLocalScheduleSendDateTime
  ) {
    const startDate = new Date(notification.LocalScheduleSendDateTime);
    const endDate = new Date(notification.MaximumLocalScheduleSendDateTime);
    const diffMinutes = Math.round(
      (endDate.getTime() - startDate.getTime()) / 60000
    );

    // Check if the diff matches one of our predefined options
    if (diffMinutes === 5 || diffMinutes === 15 || diffMinutes === 30) {
      stopSendingTimeValue = diffMinutes;
      stopSendingTimeUnit = "minutes";
    } else if (diffMinutes === 60) {
      // 1 hour
      stopSendingTimeValue = 1;
      stopSendingTimeUnit = "hours";
    } else if (diffMinutes === 180) {
      // 3 hours
      stopSendingTimeValue = 3;
      stopSendingTimeUnit = "hours";
    } else if (diffMinutes === 360) {
      // 6 hours
      stopSendingTimeValue = 6;
      stopSendingTimeUnit = "hours";
    } else if (diffMinutes === 720) {
      // 12 hours
      stopSendingTimeValue = 12;
      stopSendingTimeUnit = "hours";
    } else {
      // Custom duration
      stopSendingTimeUnit = "custom";
      if (diffMinutes <= 60) {
        stopSendingCustomValue = diffMinutes;
        stopSendingCustomUnit = "minutes";
      } else {
        stopSendingCustomValue = Math.round((diffMinutes / 60) * 10) / 10;
        stopSendingCustomUnit = "hours";
      }
    }
  }

  let filterMode: FilterMode | null;

  if (notification?.MemberFilterSegment) {
    filterMode = notification ? "segment" : null;
  } else if (!notification || isEmptyStr(notification?.MemberFilterQuery)) {
    filterMode = null;
  } else {
    filterMode = "manualFilter";
  }

  return {
    displayName: notification?.DisplayName ?? "",
    passUpdateMessage: notification?.PassUpdateMessage ?? "",
    timeZoneId: notification?.TimeZoneId ?? null,
    // Remove "Z" because this is supposed to be a local time
    sendDateTime: notification?.LocalScheduleSendDateTime?.replace("Z", "")
      ? new Date(notification?.LocalScheduleSendDateTime.replace("Z", ""))
      : null,
    endDateTime: DateUtil.utcStringToLocalDateInTimezone(
      notification?.LocationMessageOverride?.EndDateUtc,
      notification?.TimeZoneId
    ),
    memberFilterQuery: notification?.MemberFilterQuery ?? "",
    memberFilterSegment: notification?.MemberFilterSegment ?? null,
    filterMode: filterMode,
    stopSendingOption: notification?.MaximumLocalScheduleSendDateTime
      ? "specific"
      : "anytime",
    stopSendingTimeValue,
    stopSendingTimeUnit,
    stopSendingCustomUnit,
    stopSendingCustomValue,
    isScheduleRequested: false,
    locationMessageOverrides: {
      ...(notification?.LocationMessageOverride?.LocationMessageOverrides ??
        {}),
    },
  };
};
